module.exports = __webpack_public_path__ + "static/media/search-icon.bf7d4210.svg";